module.exports = __webpack_public_path__ + "img/pink-chevron-down-20x20.e86164f9.svg";